import { QueryKey, useQueryClient } from '@tanstack/react-query';

export default () => {
  const queryClient = useQueryClient();

  return async (keys: QueryKey[]) =>
    keys.forEach((key) => queryClient.invalidateQueries({ queryKey: key }));
};
